<template>
  <div v-if="hasMessage">
    <div style="width:100%;">
      <transition name="fade">
        <div :class="'status-box-condicoes '+(liberado ? 'liberado' : '')">
          <span class="span-close" @click="alertHidden"><i class="fa fa-close"></i></span>
          <p v-html="message"></p>
        </div>
      </transition>
    </div>
    <br>
  </div>
</template>
<script>
export default {
  name: 'MensagemBox',
  props: ['message', 'liberado'],
  computed: {
    hasMessage () {
      return this.message !== null &&
        typeof this.message !== 'undefined' &&
        String(this.message).trim() !== ''
    }
  },
  methods: {
    alertHidden (ev) {
      ev.currentTarget.parentNode.style = 'display:none;'
    }
  }
}
</script>
<style scoped>
.status-box-condicoes {
  width: 100%;
  padding: 15px 15px 6px;
  margin: 4px 0 0;
  border-radius: 3px;
  background: #f85e5e;
  position: relative;
}

.status-box-condicoes p {
  color: #fff !important;
  font-size: 17px;
  width: 97%;
}

.status-box-condicoes.liberado {
  background: #5ece72;
}

.span-close {
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 10px;
  text-align: center;
  padding: 4px 11px;
  font-size: 20px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/MensagemBox.vue